import {
  getCurrentLanguage,
  inAppMobile,
  nettoyerLienExterne,
  removeCurrentLanguage,
} from '@/helpers/AppHelpers';

import i18n from '@/js/i18n';
import store from '@/store';

// Extrait dans son propre helper pour éviter les dépendances circulaires entre i18n et le store
// eslint-disable-next-line import/prefer-default-export
export async function changeLanguage(newLanguage) {
  // const languages = getLanguages();
  const currentLanguage = getCurrentLanguage();

  let { pathname } = window.location;
  pathname = removeCurrentLanguage(pathname, currentLanguage);

  const pathAutreLangue = store.getters['routes/getPathAutreLangue'](pathname);
  pathname = `/${newLanguage}${pathAutreLangue}`;

  // Ceci force un redirect. Nous perdons tout ce qui est dans le store
  window.location.href = window.location.origin + pathname + window.location.search;
}

/** Méthode permettant de vérifier qu'on est sur une page où on a besoin de récuérer les préférences
 * Pages identifiées:
 *   - Collections fr/en: favoris, favourites, recents, pour-vous, for-you
 *   - Pages produits: /casino/p
 *   - Page Accueil Casino (affichage collection 'Recommendé pour vous' en mode connecté')
 */
export function isPreferencesPath(path) {
  if (
    path &&
    /(favoris|favourites|recents|pour-vous|for-you|casino\/p|casino\/accueil|casino\/home)/i.test(
      path
    )
  ) {
    return true;
  }
  return false;
}

// Vérifie si on est dans le parcours d'inscription
export function isInscriptionPath(path) {
  if (path && /(inscription\/|registration\/)/i.test(path)) {
    return true;
  }
  return false;
}

export function returnToHome() {
  // Rediriger vers la page d'accueil (TTP 13297)
  const urlRedirect = inAppMobile()
    ? i18n.t('hyperlien.appActionConnexion')
    : i18n.t('hyperlien.portailLotoQuebec');
  window.location.href = nettoyerLienExterne(urlRedirect);
}

export function returnConnexion() {
  if (inAppMobile()) {
    window.location.href = i18n.t('hyperlien.appActionConnexion');
  } else if (process.env.VUE_APP_CIAM_ENABLED === 'true') {
    // eslint-disable-next-line no-undef
    lancerConnexionAuth0(i18n.locale, window.location.href);
  } else {
    // eslint-disable-next-line no-undef
    ejConnect.ouvrirModaleLogin();
  }
}

export const erreurDefaut = {
  url: inAppMobile()
    ? i18n.t('hyperlien.appActionConnexion')
    : i18n.t('hyperlien.portailLotoQuebec'),
};
